{
  "_comment": "Generated valid naturality-square levels over S3 (boundary size 3). Exactly one candidate bottom per square makes it commute (bottom ∘ left = right ∘ top); the rest are non-natural decoys. Raw UTF-8.",
  "levels": [
    {
      "id": "tc-nat-1",
      "name": "First Squares",
      "brief": "Complete the naturality square: choose the bottom rewrite so down-then-across equals across-then-down. Only the natural rewrite commutes; a non-natural one has no slot.",
      "squares": [
        {
          "id": "tc-nat-1-a",
          "top": {
            "id": "s",
            "label": "σ",
            "perm": [
              1,
              0,
              2
            ]
          },
          "left": {
            "id": "id",
            "label": "id",
            "perm": [
              0,
              1,
              2
            ]
          },
          "right": {
            "id": "s",
            "label": "σ",
            "perm": [
              1,
              0,
              2
            ]
          },
          "candidates": [
            {
              "id": "id",
              "label": "id",
              "perm": [
                0,
                1,
                2
              ]
            },
            {
              "id": "t",
              "label": "τ",
              "perm": [
                0,
                2,
                1
              ]
            },
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            },
            {
              "id": "cyc",
              "label": "γ",
              "perm": [
                1,
                2,
                0
              ]
            }
          ]
        },
        {
          "id": "tc-nat-1-b",
          "top": {
            "id": "cyc",
            "label": "γ",
            "perm": [
              1,
              2,
              0
            ]
          },
          "left": {
            "id": "t",
            "label": "τ",
            "perm": [
              0,
              2,
              1
            ]
          },
          "right": {
            "id": "cyc2",
            "label": "γ⁻",
            "perm": [
              2,
              0,
              1
            ]
          },
          "candidates": [
            {
              "id": "t",
              "label": "τ",
              "perm": [
                0,
                2,
                1
              ]
            },
            {
              "id": "id",
              "label": "id",
              "perm": [
                0,
                1,
                2
              ]
            },
            {
              "id": "s",
              "label": "σ",
              "perm": [
                1,
                0,
                2
              ]
            },
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "tc-nat-2",
      "name": "Three Squares",
      "brief": "Three squares in a row. Each has exactly one natural completion; the boundary-crossing rewrites never commute.",
      "squares": [
        {
          "id": "tc-nat-2-a",
          "top": {
            "id": "t",
            "label": "τ",
            "perm": [
              0,
              2,
              1
            ]
          },
          "left": {
            "id": "rev",
            "label": "ρ",
            "perm": [
              2,
              1,
              0
            ]
          },
          "right": {
            "id": "s",
            "label": "σ",
            "perm": [
              1,
              0,
              2
            ]
          },
          "candidates": [
            {
              "id": "t",
              "label": "τ",
              "perm": [
                0,
                2,
                1
              ]
            },
            {
              "id": "cyc",
              "label": "γ",
              "perm": [
                1,
                2,
                0
              ]
            },
            {
              "id": "cyc2",
              "label": "γ⁻",
              "perm": [
                2,
                0,
                1
              ]
            },
            {
              "id": "id",
              "label": "id",
              "perm": [
                0,
                1,
                2
              ]
            }
          ]
        },
        {
          "id": "tc-nat-2-b",
          "top": {
            "id": "id",
            "label": "id",
            "perm": [
              0,
              1,
              2
            ]
          },
          "left": {
            "id": "cyc",
            "label": "γ",
            "perm": [
              1,
              2,
              0
            ]
          },
          "right": {
            "id": "t",
            "label": "τ",
            "perm": [
              0,
              2,
              1
            ]
          },
          "candidates": [
            {
              "id": "s",
              "label": "σ",
              "perm": [
                1,
                0,
                2
              ]
            },
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            },
            {
              "id": "cyc2",
              "label": "γ⁻",
              "perm": [
                2,
                0,
                1
              ]
            }
          ]
        },
        {
          "id": "tc-nat-2-c",
          "top": {
            "id": "cyc2",
            "label": "γ⁻",
            "perm": [
              2,
              0,
              1
            ]
          },
          "left": {
            "id": "id",
            "label": "id",
            "perm": [
              0,
              1,
              2
            ]
          },
          "right": {
            "id": "cyc2",
            "label": "γ⁻",
            "perm": [
              2,
              0,
              1
            ]
          },
          "candidates": [
            {
              "id": "cyc",
              "label": "γ",
              "perm": [
                1,
                2,
                0
              ]
            },
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            },
            {
              "id": "s",
              "label": "σ",
              "perm": [
                1,
                0,
                2
              ]
            },
            {
              "id": "t",
              "label": "τ",
              "perm": [
                0,
                2,
                1
              ]
            }
          ]
        }
      ]
    },
    {
      "id": "tc-nat-3",
      "name": "Boundary Run",
      "brief": "A longer run of squares. The natural witness is unique each time; the non-natural 2-cells are unconstructable.",
      "squares": [
        {
          "id": "tc-nat-3-a",
          "top": {
            "id": "rev",
            "label": "ρ",
            "perm": [
              2,
              1,
              0
            ]
          },
          "left": {
            "id": "s",
            "label": "σ",
            "perm": [
              1,
              0,
              2
            ]
          },
          "right": {
            "id": "t",
            "label": "τ",
            "perm": [
              0,
              2,
              1
            ]
          },
          "candidates": [
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            },
            {
              "id": "cyc",
              "label": "γ",
              "perm": [
                1,
                2,
                0
              ]
            },
            {
              "id": "id",
              "label": "id",
              "perm": [
                0,
                1,
                2
              ]
            },
            {
              "id": "cyc2",
              "label": "γ⁻",
              "perm": [
                2,
                0,
                1
              ]
            }
          ]
        },
        {
          "id": "tc-nat-3-b",
          "top": {
            "id": "s",
            "label": "σ",
            "perm": [
              1,
              0,
              2
            ]
          },
          "left": {
            "id": "cyc",
            "label": "γ",
            "perm": [
              1,
              2,
              0
            ]
          },
          "right": {
            "id": "cyc",
            "label": "γ",
            "perm": [
              1,
              2,
              0
            ]
          },
          "candidates": [
            {
              "id": "t",
              "label": "τ",
              "perm": [
                0,
                2,
                1
              ]
            },
            {
              "id": "rev",
              "label": "ρ",
              "perm": [
                2,
                1,
                0
              ]
            },
            {
              "id": "id",
              "label": "id",
              "perm": [
                0,
                1,
                2
              ]
            }
          ]
        }
      ]
    }
  ]
}
